import React from 'react'
import PropTypes from 'prop-types'

const Rating = ({ value, text }) => {
  return (
    <div className='text-yellow-300 my-1'>
      <span>
        <i
          className={`${
            value >= 1 ? 'fas fa-star' : value >= 0.5 ? 'fas fa-star-half-alt' : 'far fa-star'
          }`}
        ></i>
      </span>
      <span>
        <i
          className={`${
            value >= 2 ? 'fas fa-star' : value >= 1.5 ? 'fas fa-star-half-alt' : 'far fa-star'
          }`}
        ></i>
      </span>
      <span>
        <i
          className={`${
            value >= 3 ? 'fas fa-star' : value >= 2.5 ? 'fas fa-star-half-alt' : 'far fa-star'
          }`}
        ></i>
      </span>
      <span>
        <i
          className={`${
            value >= 4 ? 'fas fa-star' : value >= 3.5 ? 'fas fa-star-half-alt' : 'far fa-star'
          }`}
        ></i>
      </span>
      <span>
        <i
          className={`${
            value >= 5 ? 'fas fa-star' : value >= 4.5 ? 'fas fa-star-half-alt' : 'far fa-star'
          }`}
        ></i>
      </span>
      <span className='ml-2 text-gray-800'>{text && `${text} reviews`}</span>
      <i></i>
    </div>
  )
}
Rating.propTypes = {
  value: PropTypes.string,
  text: PropTypes.string
}

export default Rating
